/* rein-lead.js — SERVICE-POSITIONING 2026-10-20.
 * Every lead form calls ReinLead.capture(form, key) in its submit listener and ReinLead.flush(key) on its success load.
 * capture() stores the submitted fields in sessionStorage; flush() posts ONE Klaviyo client event "Rein Lead Submitted"
 * (public company id only, no API key) and deletes the record, so a reload or a bare visit to the success URL sends nothing.
 * The event writes lead_source / lead_product_ref / lead_zip / water_source onto the Klaviyo profile and triggers the
 * internal alert flow "Internal — New Lead Alert" (to contact@reinwaterusa.com + the owner). It never subscribes anyone and
 * never emails the customer. Test submissions (email contains +reintest or URL has rein_test=1) still alert, labelled TEST.
 */
(function () {
  if (window.ReinLead) return;
  var CO = 'QTsEhc', METRIC = 'Rein Lead Submitted', PFX = 'rein-lead-pending:';
  var SOURCES = { match: 'Free Water Match', quiz: 'Quiz', freight: 'Freight quote', commercial: 'Commercial quote', consult: 'Consultation' };
  var SKIP = /^(gclid|gbraid|wbraid|Fax|tags|Request|Request type|accepts_marketing)$/;
  function ss(fn) { try { return fn(); } catch (e) { return null; } }
  function clean(o) { var r = {}; for (var k in o) { if (o[k] !== undefined && o[k] !== null && o[k] !== '') r[k] = o[k]; } return r; }
  function fields(form) {
    var out = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      var m = /^contact\[(.+)\]$/.exec(el.name || '');
      if (!m || SKIP.test(m[1])) return;
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      var v = String(el.value || '').trim();
      if (v) out[m[1]] = out[m[1]] ? out[m[1]] + ', ' + v : v;
    });
    return out;
  }
  function pick(f, names) { for (var i = 0; i < names.length; i++) { if (f[names[i]]) { var v = f[names[i]]; delete f[names[i]]; return v; } } return ''; }
  function isTest(email) {
    var p = ss(function () { return new URLSearchParams(window.location.search); });
    return !!((p && p.get('rein_test') === '1') || /\+reintest/i.test(email || ''));
  }
  window.ReinLead = {
    /* submit listener: remember what was sent (one record per form key; a captcha resubmit keeps the same sid) */
    capture: function (form, key, extra) {
      var f = fields(form); for (var k in (extra || {})) { if (extra[k]) f[k] = extra[k]; }
      var old = ss(function () { return JSON.parse(sessionStorage.getItem(PFX + key) || 'null'); });
      var rec = { sid: (old && old.sid) || (key + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8)), fields: f, page: window.location.pathname };
      ss(function () { sessionStorage.setItem(PFX + key, JSON.stringify(rec)); });
      return rec;
    },
    peek: function (key) { return ss(function () { return JSON.parse(sessionStorage.getItem(PFX + key) || 'null'); }); },
    /* no email available (Calendly embed): anonymous event, still triggers the internal alert */
    anon: function (key, sid, extra) {
      var test = !!(extra && extra.test);
      var d = clean({ source: (test ? 'TEST ' : '') + (SOURCES[key] || key), source_key: key, details: extra && extra.details, submission_id: sid, test: test || undefined,
        page_url: window.location.origin + window.location.pathname, submitted_at: new Date().toISOString() });
      return this._post(d, { anonymous_id: sid });
    },
    _post: function (d, profile) {
      var body = { data: { type: 'event', attributes: { properties: d, unique_id: d.submission_id,
        metric: { data: { type: 'metric', attributes: { name: METRIC } } },
        profile: { data: { type: 'profile', attributes: profile } } } } };
      return fetch('https://a.klaviyo.com/client/events?company_id=' + CO, {
        method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      }).then(function (r) { console.info('[rein-lead] klaviyo lead event HTTP ' + r.status + (d.test ? ' (test)' : '')); return { status: r.status, data: d }; })
        .catch(function () { return null; });
    },
    /* success load: post the event once, then forget the record */
    flush: function (key, sidOverride) {
      var rec = this.peek(key);
      ss(function () { sessionStorage.removeItem(PFX + key); });
      if (!rec || !rec.fields) return null;
      var f = JSON.parse(JSON.stringify(rec.fields));
      var email = pick(f, ['email']); if (!email) return null;
      var name = pick(f, ['First name', 'name']); var test = isTest(email);
      var d = clean({
        source: (test ? 'TEST ' : '') + (SOURCES[key] || key), source_key: key, email: email,
        first_name: (name || '').split(/\s+/)[0], full_name: name, phone: pick(f, ['phone', 'Phone']),
        zip: pick(f, ['ZIP code', 'Ship-to ZIP', 'ZIP']), water_source: pick(f, ['Water source']),
        concern: pick(f, ["What's bothering you"]), scope: pick(f, ['Drinking water or whole house']),
        notes: pick(f, ['body', 'comment', 'Notes']), product_ref: pick(f, ['Product handle']),
        product_title: pick(f, ['Product title', 'Product']), ref: pick(f, ['Ref']), quiz_result: pick(f, ['Quiz result']),
        submission_id: sidOverride || rec.sid, test: test || undefined,
        page_url: window.location.origin + (rec.page || window.location.pathname), submitted_at: new Date().toISOString()
      });
      var rest = Object.keys(f).map(function (k) { return k + ': ' + f[k]; }).join(' · ');
      if (rest) d.details = rest;
      var profile = clean({ email: email, first_name: d.first_name, properties: clean({
        lead_source: key, lead_product_ref: d.product_ref, lead_zip: d.zip, water_source: d.water_source, lead_last_submitted: d.submitted_at }) });
      return this._post(d, profile);
    }
  };
})();
